import { Injectable, signal } from '@angular/core';
import { IUnsavedChangesRequest } from 'src/app/models';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private readonly checks = new Set<() => boolean>();
  private pendingRequest?: IUnsavedChangesRequest;
  private pendingAnswer?: Promise<boolean>;
  readonly request = signal<IUnsavedChangesRequest | undefined>(undefined);
  readonly descriptionKey = signal('');

  register(hasUnsavedChanges: () => boolean): () => void {
    this.checks.add(hasUnsavedChanges);
    return () => this.checks.delete(hasUnsavedChanges);
  }

  hasUnsavedChanges(): boolean {
    for (const hasUnsavedChanges of this.checks) {
      if (hasUnsavedChanges()) return true;
    }
    return false;
  }

  confirmDiscard(descriptionKey: string): Promise<boolean> {
    if (!this.hasUnsavedChanges()) return Promise.resolve(true);
    if (this.pendingAnswer) return this.pendingAnswer;
    this.pendingAnswer = new Promise((resolve) => {
      this.pendingRequest = { descriptionKey, resolve };
      this.descriptionKey.set(descriptionKey);
      this.request.set(this.pendingRequest);
    });
    return this.pendingAnswer;
  }

  answer(leave: boolean) {
    const pendingRequest = this.pendingRequest;
    this.pendingRequest = undefined;
    this.pendingAnswer = undefined;
    this.request.set(undefined);
    pendingRequest?.resolve(leave);
  }
}
